export default import.meta.ROLLDOWN_FILE_URL_1v0AqR0qVC6WAjKyAFdnew